// src/services/autoArchiveService.js
import { getData, saveData } from './storageService';

export const autoArchiveReports = async () => {
  try {
    const activeReport = await getData('active_technician_report');
    const archivedReports = await getData('technician_reports') || [];
    
    // Перевіряємо чи є активний звіт для архівації
    if (activeReport && activeReport.status === 'completed') {
      // Додаємо дату архівації та класифікуємо проблеми
      const reportToArchive = {
        ...activeReport,
        archivedAt: new Date().toISOString(),
        archivedBy: 'system',
        issueTypes: classifyReportByIssues(activeReport),
        hasPhotos: !!(activeReport.photos && activeReport.photos.length > 0),
        photoCount: activeReport.photos ? activeReport.photos.length : 0
      };
      
      // Додаємо в архів
      const updatedArchived = [...archivedReports, reportToArchive];
      await saveData('technician_reports', updatedArchived);
      
      // Видаляємо активний звіт
      await saveData('active_technician_report', null);
      
      console.log('Report auto-archived successfully');
      return true;
    }
    
    return false;
  } catch (error) {
    console.error('Auto-archive error:', error);
    return false;
  }
};

export const classifyReportByIssues = (report) => {
  const issues = [];
  
  // Аналізуємо дані звіту для класифікації
  if (report.data?.calderas) {
    const calderas = report.data.calderas;
    if (calderas.presion && parseFloat(calderas.presion) < 2.0) {
      issues.push('low_pressure');
    }
    if (calderas.nivel_agua && parseFloat(calderas.nivel_agua) < 80) {
      issues.push('low_water_level');
    }
    if (calderas.temp_acs && parseFloat(calderas.temp_acs) < 60) {
      issues.push('low_temperature');
    }
  }
  
  // Аналіз інших секцій...
  if (report.data?.kannegiesser) {
    report.data.kannegiesser.forEach((machine, index) => {
      const totalPieces = [machine.pieces1, machine.pieces2, machine.pieces3, machine.pieces4]
        .reduce((sum, val) => sum + (parseInt(val) || 0), 0);
      
      if (totalPieces < 50) {
        issues.push(`low_productivity_machine_${index + 1}`);
      }
    });
  }

  // Аналіз фото на наявність критичних проблем
  if (report.photos && report.photos.length > 0) {
    const photoDescriptions = report.photos.map(photo => photo.description.toLowerCase());
    
    if (photoDescriptions.some(desc => 
      desc.includes('leak') || desc.includes('fuga') || desc.includes('fuite'))) {
      issues.push('leak_detected');
    }
    
    if (photoDescriptions.some(desc => 
      desc.includes('broken') || desc.includes('roto') || desc.includes('cassé'))) {
      issues.push('broken_part');
    }
    
    if (photoDescriptions.some(desc => 
      desc.includes('corrosion') || desc.includes('rust') || desc.includes('óxido'))) {
      issues.push('corrosion');
    }
  }
  
  return issues;
};

// Функція для отримання звітів з фото
export const getReportsWithPhotos = async () => {
  try {
    const reports = await getData('technician_reports') || [];
    return reports.filter(report => report.hasPhotos);
  } catch (error) {
    console.error('Error getting reports with photos:', error);
    return [];
  }
};

// Функція для пошуку звітів за типом проблеми
export const getReportsByIssueType = async (issueType) => {
  try {
    const reports = await getData('technician_reports') || [];
    return reports.filter(report => 
      report.issueTypes && report.issueTypes.includes(issueType)
    );
  } catch (error) {
    console.error('Error getting reports by issue type:', error);
    return [];
  }
};